import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/Dashboard/dashboard.vue";

// Location
import Location from "../views/Location/location.vue";
import LocationCreate from "../views/Location/create.vue";
import LocationUpdate from "../views/Location/update.vue";

// UserLocation
import UserLocation from "../views/UserLocations/userLocation.vue";

// Job Readiness
import JobReadinessList from "@/views/JobReadiness/datalist.vue";

// Presence
import Presence from "@/views/Presence/datalist.vue";
import PresenceDetail from "@/views/Presence/details.vue";

// Restricted Area 
import Restricted_Area from "@/views/Restricted_Area/restricted_area.vue";

//  Notitfication 
import Running_Text from "@/views/Notification/Running_Text/running_text.vue";

// Mastering 
import Mustering from "@/views/Mustering/mutering.vue"
import MusteringDetails from "@/views/Mustering/detail.vue"

import SickLeave from "@/views/SickLeave"
import SickLeaveDetail from "@/views/SickLeave/detail"

// Wake up call
import WakeUpCall from "@/views/WakeUpCall"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/person-on-board",
    name: "UserLocation",
    component: UserLocation,
  },
  {
    path: "/location",
    name: "Location Area",
    component: Location,
  },
  {
    path: "/location/create",
    name: "Location Area",
    component: LocationCreate,
  },
  {
    path: "/location/:id/update",
    name: "Location Area",
    component: LocationUpdate,
  },
  {
    path: "/job-readiness",
    name: "JobReadinessList",
    component: JobReadinessList,
  },
  {
    path: "/presence",
    name: "PresenceList",
    component: Presence,
  },
  {
    path: "/presence-detail",
    name: "PresenceDetail",
    component: PresenceDetail,
  },
  {
    path: "/restricted-area",
    name: "Restricted Area",
    component: Restricted_Area,
  },
  {
    path: "/running-text",
    name: "Running Text",
    component: Running_Text,
  },
  {
    path: "/mustering",
    name: "Mustering",
    component: Mustering,
  },
  {
    path: "/mustering/:id/details",
    name: "MusteringDetail",
    component: MusteringDetails,
  },
  {
    path: "/sick-leave",
    name: "SickLeave",
    component: SickLeave,
  },
  {
    path: "/sick-leave/:id",
    name: "SickLeaveDetail",
    component: SickLeaveDetail,
  },
  {
    path: "/wake-up-call",
    name: "WakeUpCall",
    component: WakeUpCall,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
